import { useEntitySelection } from '@shared/api/providers/entitySelection';
import { Menu } from '@shared/components/Menu';
import { Entity } from '@shared/data/entity/Entity';
import { i18n } from '@shared/util/i18n';

interface Props {
  entity: Entity;
}

export function SelectMultipleMenuItem({ entity }: Props) {
  const entitySelection = useEntitySelection();

  return (
    <Menu.Item
      label={i18n('card.menu.actions.selectMultiple')}
      onClick={() => entitySelection.addEntity(entity)}
    />
  );
}
